export default __webpack_public_path__ + "static/pokebase-a70ada65a2efdf0d84f6900902ed9853.png";